import { useCallback } from 'react';
import { createPath, useLocation, useNavigate } from 'react-router-dom';
import { useStateInRef } from 'seagull';
import { useOverlayContext } from '~/contexts';
import { useIoContext } from '~/providers/IoContext';
const ROUTE_PRELOAD_LOADER = 'route-preload';
export function usePreloadNavigate() {
    const navigate = useNavigate();
    const { startLoader, stopLoader } = useOverlayContext();
    const { browser, chunks } = useIoContext();
    const getLocation = useStateInRef(useLocation());
    return useCallback((path)=>{
        browser.afterNextPaint(()=>{
            chunks.navigateWhenRouteReady(path, {
                navigate: ()=>navigate(path, {
                        replace: createPath(getLocation()) === path
                    }),
                startWaiting: ()=>startLoader(ROUTE_PRELOAD_LOADER),
                stopWaiting: ()=>stopLoader(ROUTE_PRELOAD_LOADER)
            });
        });
    }, []);
}
